<template>
    <main id="machine-sheet-showroom" v-if="displayContent">
        <div class="wrapper">
            <template v-if="showroomDisplayable" >
<!--                <h2 class="title is-2">{{ $t("showroom") }}</h2>-->
                <div class="showroom-container" >
                    <sheet-block-picture-video-showroom :pictures="pictures" :videos="videos"  v-if="showroomDisplayable"/>
                </div>

<!--                <div class="titled-container main-video-container" v-if="youtubeVideo">
                    <h3 class="title is-3">
                        {{ youtubeVideo.title }}
                    </h3>
                    <a
                        class="video-block"
                        :style="`background-image: url(${youtubeVideo.thumbnail});`"
                        data-mediabox="main-video"
                        :href="youtubeVideo.embed"
                        :data-width="lightboxVideoWidth"
                        :data-height="lightboxVideoHeight"
                        aria-label="video"
                        @click="enableBlur()"
                    >
                        <span class="icon-play"></span>
                    </a>
                </div>-->
            </template>
            <template v-else>
                <div class="content-available-soon">
                    {{ $t('content_available_soon') }}
                </div>
            </template>
        </div>
    </main>
</template>

<script>
    import { mapState } from 'vuex'
    import videoService from "@/services/youtube/video";

    import SheetBlockAssociatedDocuments from "@/components/SheetBlock/SheetBlockAssociatedDocuments";
    import playlistService from "@/services/youtube/playlist";
    import SheetBlockPictureVideoShowroom from "@/components/SheetBlock/SheetBlockPictureVideoShowroom";

    export default {
        name: 'ServiceShowroomView',
        components: {
            SheetBlockAssociatedDocuments,
            SheetBlockPictureVideoShowroom,
        },
        data() {
            return {
                displayContent: false,
                youtubeVideo: null,
                showroomDisplayable: false,
                pictures: [],
                videos: [],
                reduceRisksVideos: []
            }
        },
        computed: {
            ...mapState({
                productDatas: state => state.sheet.productDatas
            }),
        },
        created(){
            this.startLoading();

            let promisesArray = [
              this.getTessaVideo(),
              this.getYoutubeVideo(),
              this.fetchMainVisual(),
            ];

            this.speedTrackingShowroom = new Date().getTime();

            Promise.all(promisesArray).then(() => {
                if( this.pictures.length > 0 || this.videos.length > 0)
                    this.showroomDisplayable = true;

                this.stopLoading()
                this.displayContent = true;

                let promisesArrayDocuments = [
                    this.fetchReduceRisks(),
                ];

                this.speedTrackingDocuments = new Date().getTime();
                return Promise.all(promisesArrayDocuments);

            }).finally(() => {
                this.$nextTick(() => {
                    if(this.reduceRisksVideos.length > 0)
                        this.$root.wamediabox.bindAll(document.querySelector(".reduce-risks-container"));
                })
            });

            //this.speedTrackingShowroomTrigger('machine', this.productDatas.identifier, this.productDatas.values.reference_name);

            /*this.getYoutubeVideo().finally(() => {
                this.stopLoading()
                this.displayContent = true;

                if(this.youtubeVideo || this.videos.length > 0)
                    this.contentAvailable = true;

                this.$nextTick(() => {
                    if(this.youtubeVideo)
                        this.$root.wamediabox.bind(document.querySelector(".video-block"));
                })
            });*/
        },
        methods: {
            /*async getYoutubeVideo(){
                if(this.productDatas.values.youtube_video)
                    return videoService.get(this.productDatas.values.youtube_video).then((response) => {
                        console.log(response);
                        this.youtubeVideo = response.data.data
                    })
            },*/
            getTessaVideo() {
              if (this.productDatas.values.video && this.productDatas.values.video.length > 0) {
                this.productDatas.values.video.forEach(video => {
                  this.videos.push({
                    type: 'video',
                    src: (video.indexOf('http')> -1) ? video : process.env.VUE_APP_SERLI_API + video,
                    thumb: '',
                  })
                })
              }
            },
            async getYoutubeVideo(){
                let youtubeVideos = [
                    'youtube_video',
                    'youtube_range',
                    'youtube_other',
                ]

                for(const youtubeVideo of youtubeVideos) {
                    if(this.productDatas.values[youtubeVideo]) {
                        //correctif pour mauvaise qualif akeneo
                        if(this.productDatas.values[youtubeVideo].code.indexOf('&list=')>1) this.productDatas.values[youtubeVideo].code=this.productDatas.values[youtubeVideo].code.split('&list=')[1]
                        if(this.productDatas.values[youtubeVideo].code.indexOf('&')>1) this.productDatas.values[youtubeVideo].code=this.productDatas.values[youtubeVideo].code.split('&')[0]

                        let url = 'https://www.youtube.com/embed/';
                        if (this.productDatas.values[youtubeVideo].code.length > 11) {
                            const response=await playlistService.getVideos(this.productDatas.values[youtubeVideo].code, {withDetails: true})
                            for (const video of response.data.data) {
                                this.videos.push({
                                    type: 'video',
                                    src: 'https://img.youtube.com/vi/' + video.code + '/sddefault.jpg',
                                    embed: video.embed,
                                    thumb: 'https://i.ytimg.com/vi/' + video.code + '/hqdefault.jpg',
                                })
                            }
                        } else {
                            url = url + this.productDatas.values[youtubeVideo].code + '?autoplay=1';
                            this.videos.push({
                                type: 'video',
                                src: 'https://img.youtube.com/vi/' + this.productDatas.values[youtubeVideo].code + '/sddefault.jpg',
                                embed: url,
                                thumb: 'https://i.ytimg.com/vi/' + this.productDatas.values[youtubeVideo].code + '/hqdefault.jpg',
                            })
                        }
                    }
                }
            },
            fetchReduceRisks(){
                if(this.productDatas.values['youtube_reduce_program']) {
                    //Correctif pour mauvaise qualification
                    if (this.productDatas.values['youtube_reduce_program'].code.indexOf('&list=') > 1) this.productDatas.values['youtube_reduce_program'].code = this.productDatas.values['youtube_reduce_program'].code.split('&list=')[1]
                    return playlistService.getVideos(this.productDatas.values['youtube_reduce_program'].code, {withDetails: true}).then((response) => {
                        if (response.data.data) {
                            this.reduceRisksVideos = response.data.data
                            this.videos = this.videos.concat(this.reduceRisksVideos);
                        }
                    })
                }
            },
        }
    }
</script>


<style lang="scss">
    #machine-sheet-showroom {
        padding-top: 35px;
        padding-bottom: 40px;

        .showroom-container {
            padding-left: 30px;

            @media #{$mq_phone} {
                padding-left: 20px;
                padding-right: 20px;
            }
        }
    }
</style>

